import React from 'react';
import { MouseGlow, AmbientGlow } from './MouseGlow';
import { AnimatedGrain, Scanlines, Vignette } from './NoiseFilter';

interface EnvironmentEffectsProps {
  theme: string;
  enableMouseGlow?: boolean;
  enableGrain?: boolean;
  enableScanlines?: boolean;
  enableVignette?: boolean;
}

/**
 * Master component that applies environmental effects based on the active theme
 * - Glassmorphism: Mouse glow, ambient lighting
 * - Futuristic: Grain texture, scanlines, vignette
 * - Minimal: No effects (clean aesthetic)
 */
export const EnvironmentEffects: React.FC<EnvironmentEffectsProps> = ({
  theme,
  enableMouseGlow = true,
  enableGrain = true,
  enableScanlines = true,
  enableVignette = true,
}) => {
  // Glassmorphism effects
  if (theme === 'glassmorphism') {
    return (
      <>
        {enableMouseGlow && (
          <MouseGlow
            enabled={true}
            color="rgba(6, 182, 212, 0.12)"
            size={500}
            intensity={0.8}
          />
        )}
        <AmbientGlow theme={theme} />
      </>
    );
  }

  // Futuristic effects
  if (theme === 'futuristic') {
    return (
      <>
        {enableGrain && <AnimatedGrain intensity={0.025} />}
        {enableScanlines && <Scanlines opacity={0.02} spacing={3} />}
        {enableVignette && <Vignette intensity={0.5} />}
        {enableMouseGlow && (
          <MouseGlow
            enabled={true}
            color="rgba(0, 255, 255, 0.08)"
            size={600}
            intensity={0.6}
          />
        )}
      </>
    );
  }

  // Minimal theme has no environmental effects
  return null;
};

export default EnvironmentEffects;
